export const calendar = {
  title: 'Vue Calendrier',
  subtitle: 'Aperçu visuel de vos réservations',
  
  // Calendar navigation
  today: 'Aujourd\'hui',
  month: 'Mois',
  week: 'Semaine',
  day: 'Jour',
  list: 'Liste',
  
  // Event types
  pickup: 'Prise en charge',
  return: 'Retour',
  maintenance: 'Maintenance',
  blocked: 'Bloqué',
  
  // Actions
  addEvent: 'Ajouter un Événement',
  editEvent: 'Modifier l\'Événement',
  deleteEvent: 'Supprimer l\'Événement',
  viewDetails: 'Voir les Détails',
  
  // Time
  allDay: 'Toute la journée',
  startTime: 'Heure de début',
  endTime: 'Heure de fin',
  
  // Messages
  noEvents: 'Aucun événement',
  noEventsDesc: 'Aucun événement prévu pour cette période.',
  eventCreated: 'Événement créé avec succès',
  eventUpdated: 'Événement mis à jour avec succès',
  eventDeleted: 'Événement supprimé avec succès',
}; 